module.exports = __webpack_public_path__ + "img/icon-discord.d6dc3312.svg";